module.exports = __webpack_public_path__ + "media/mapview.c10fb3d7.svg";